import buildings from "../Assets/buildings.png"
import Call from "../Assets/Call.png"
import Mail from "../Assets/Mail.png"
import ContactCard from "../Utils/ContactCard"
import Input from "../Utils/Input"
import { ErrorMessage, Field, Form, Formik, useFormik, useFormikContext } from "formik";
import * as yup from "yup";
import axios from "axios"
import { toast } from "react-toastify";

// let url=process.env.REACT_APP_BASE_URL

const schema=yup.object().shape({
    phonenumber:yup.string()
    .matches(/^\d+$/, 'Phone number must only contain digits')
    .max(10,"Phone number must be of 10 digits")
    .min(10,"Phone number must be of 10 digits")
    .required("Phone Number is required"),
    name:yup.string()
    .matches(/^[a-z ,.'-]+$/i,'Name must not contain special characters')
    .required("Name is required"),
    email:yup.string()
    .required("Email is required")
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,'Invalid email'),
    message:yup.string()
})
const GetStarted=({mycontactref})=>
{
    let data=[
        {"url":Call,"title":"Call Here","description":"+91 9305879960"},
        {"url":Mail,"title":"Mail Here","description":"reservations@brikitt.com"}
]
const formdata=[
    {"title":"Full Name:",name:"name",component:"",placeholder:"YOUR FULL NAME"},
    {"title":"Email Id:",name:"email",component:"",placeholder:"YOUR EMAIL"},
    {"title":"Phone number:",name:"phonenumber",component:"",placeholder:"YOUR PHONE NUMBER"},
    {"title":"Message:",name:"message",component:"textarea",placeholder:"YOUR MESSAGE"}]

    const initialValues={
        
        phonenumber:"",
        email:"",
        name:"",
        message:''
    }
    const handleSubmit=(values,helpers)=>
    {
        let body={
            "name":values.name,
            "email":values.email,
            "mobile_number":values.phonenumber,
            "message":values.message
        }
        axios.post('https://broker-dev.brikitt.com/api/leads/property_management/new/',body)
        .then((res)=>{
            toast.success("The request has been successfully sent and you will receive a callback soon")
            
            // alert("The request has been successfully sent and you will receive a callback soon")
            helpers.resetForm({initialValues})
        })
        .catch((e)=>toast.error("Something went wrong"))
    }

    return(
        <div style={{backgroundImage:`url(${buildings})`,backgroundRepeat:"no-repeat",backgroundSize:"cover"}}  className="relative">
            <div className="sm:px-[16px] sm:py-[30px] lg:px-[140px] lg:pt-[110px] lg:pb-[20px]">
                <p style={{fontFamily:"Playfair Display"}} className="sm:text-[24px] lg:text-[35px] font-[400] text-white sm:leading-[35px] lg:leading-[63px] sm:mb-[10px] lg:mb-[30px]">GET STARTED ON YOUR JOURNEY</p>
                {/* <p style={{fontFamily:"Inter"}} className="lg:w-[470px] text-[16px] font-[400] text-white leading-[26px] mb-[30px]">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam ipsum egestas ullamcorper ultrices arcu nunc, </p> */}
                {/* <button style={{fontFamily:"Inter"}} className="px-[35px] py-[15px] border-2 border-white text-white sm:text-[14px] lg:text-[16px] font-[500] leading-[20px] tracking-[2px]">CONTACT US</button> */}
            </div>
            <div className="sm:px-[16px] sm:py-[1px] lg:px-[140px] lg:pb-[40px]">
                <div className="sm:block lg:flex flex-col lg:gap-[70px]">
                {
                    data?.map((e,i)=>
                    {
                        return <ContactCard url={e.url} title={e.title} text={e.description} />
                    })
                }
                </div>
            </div>
            <Formik
                initialValues={initialValues}
                validationSchema={schema}
                onSubmit={handleSubmit}>
            <Form>
                <div ref={mycontactref} style={{fontFamily:"Inter"}} className="bg-white flex flex-col justify-center lg:px-[40px] sm:px-[16px] lg:py-[40px] sm:py-[30px] lg:rounded-[10px] sm:block xl:absolute left-[60%] top-[102px] lg:shadow-xl">
                    <p  className="text-[24px] text-[#212630] text-center font-[700] leading-[30px] tracking-[3%] mb-[26px]">CONNECT WITH US</p>
                    <div className="flex flex-col">
                        {
                            formdata?.map((e,i)=>
                            {
                                return (
                                    <>
                                        <label style={{fontFamily:"Inter"}} className="text-[16px] text-black font-[400] leading-[20px] mb-[5px]">{e.title}</label>
                                            <Field className="rounded-[2px] border border-gray sm:w-full lg:w-[380px] px-[20px] py-[12px] mb-[15px] text-[14px] text-[#787878] tracking-[2px] font-[400]" placeholder={e.placeholder} key={i} title={e.title} name={e.name} type="text" component={e.component} />
                                        <ErrorMessage className='text-[#FF0000] text-[14px] text-center font-[400] leading-[20px]' name={e.name} component="div"/>
                                    </>
                                )
                            })
                        }
                    </div>
                    <button id="activeeffect" type="submit" onSubmit={handleSubmit} className="flex flex-col justify-center items-center sm:w-full hover:bg-[#a77202] lg:w-[280px] lg:m-auto lg:mt-[25px] py-[15px] bg-[#C69130] text-white text-[16px] font-[500] leading-[20px]">REQUEST A CALLBACK</button>
                </div>
            </Form>

            </Formik>
        </div>
    )
}
export default GetStarted